



















































































































import {Component, Vue} from 'vue-property-decorator';
import {create, search, updateActive} from "@/_services/user.services";
import {IUser, IUserEdit, Role} from "@/_objects/IUser";
import Confirm from "@/components/Confirm.vue";
import {SNACK_ACTION} from "@/_store/snackbar";
import {store} from "@/_store";
import UsersEdit from "@/secure/UsersEdit.vue";

interface IViewModel {
    id: string;
    isActive: boolean;
    date: Date;
    name: string;
    role: Role;
    company: string;
}
@Component({
    components: {UsersEdit, Confirm},
})
export default class Users extends Vue {
    private static getBlankEditUser(): IUserEdit {
        return {
            first: "",
            last: "",
            email: "",
            id: "",
            role: Role.PUBLISHER,
            company: "",
        };
    }

    private static splitCsv(str: string): string[][] {
        return str.trim().split("\n").map((row: string) => {
            return row.trim().split(",");
        });
    }

    private static validateHeader(header: string[]) {
        return (
            header[0].toLowerCase().trim() === "first" &&
            header[1].toLowerCase().trim() === "last" &&
            header[2].toLowerCase().trim() === "email" &&
            header[3].toLowerCase().trim() === "company" &&
            header[4].toLowerCase().trim() === "role"
        );
    }

    private static async addUser(user: IUserEdit) {
        const newUser = await create(user);
        if (newUser) {
            store.dispatch(SNACK_ACTION.SUCCESS, `<b>${newUser.first} ${newUser.last}</b> has been created.`);
        }
    }

    private loading: boolean = true;
    private list: IViewModel[] = [];
    private dialogActiveShow: boolean = false;
    private dialogActiveMsg: string = "";
    private dialogActiveData: {} = {};
    private dialogEditShow: boolean = false;
    private dialogEditUser: IUserEdit = Users.getBlankEditUser();
    private users: IUser[] = [];

    private headers = [
        { text: 'Name', value: 'name' },
        { text: 'Company', value: 'company' },
        { text: 'Role', value: 'role' },
        { text: 'Active', value: 'isActive' },
        { text: '', value: '' },
        ];


    private async reload() {
        this.loading = true;
        this.users = await search();
        this.loading = false;
        this.list = this.users.map((user) => {
            return {
                id: user.id,
                isActive: user.isActive,
                date: user.date,
                name: user.first + ' ' + user.last,
                role: user.role,
                company: user.company,
            };
        });
    }
    private async created() {
        await this.reload();
    }

    private async onConfirmActiveUpdate(data: any) {
        this.loading = true;

        try {
            await updateActive(data.user.id, data.isActive);
            if (!data.isActive) {
                store.dispatch(SNACK_ACTION.WARNING, `<b>${data.user.name}</b> has been de-activated.`);
            } else {
                store.dispatch(SNACK_ACTION.SUCCESS, `<b>${data.user.name}</b> has been activated.`);
            }
        } catch (error) {
            // Do nothing;
        }

        this.loading = false;
        this.reload();
    }

    private toggleActive(isActive: boolean, user: IViewModel) {
        this.dialogActiveShow = true;
        this.dialogActiveData = {isActive, user};
        if (!isActive) {

            this.dialogActiveMsg = `Are you sure you want to de-activate <b>${user.name}</b>?`;
        } else {
            this.dialogActiveMsg = `Are you sure you want to activate <b>${user.name}</b>?`;
        }
    }

    private editUser(id: string) {
        this.dialogEditShow = true;
        this.dialogEditUser = Users.getBlankEditUser();
        if (id) {
            const fullUser = this.users.find((user) => {
                return user.id === id;
            });

            if (fullUser !== undefined) {
                this.dialogEditUser = {
                    first: fullUser.first,
                    last: fullUser.last,
                    email: fullUser.email,
                    id: fullUser.id,
                    role: fullUser.role,
                    company: fullUser.company,
                };
            }
        }
    }

    private pickFile() {
        (this.$refs.uploadInput as any).click();
    }

    private async onFilePicked(e: any) {
        const file = e.target.files[0];

        const reader = new FileReader();
        reader.readAsText(file);
        reader.onload = async () => {
            const data: string[][] = Users.splitCsv(reader.result as string);
            if (data.length < 2) {
                store.dispatch(SNACK_ACTION.ERROR, `Not enough rows found in csv.`);
            } else if (!Users.validateHeader(data[0])) {
                store.dispatch(SNACK_ACTION.ERROR, `Please make sure this is the header: First, Last, Email, Company, Role`);
            } else {
                const series = async () => {
                    for (let i = 1; i < data.length; i++) {
                        await Users.addUser({
                            id: "",
                            first: data[i][0].trim(),
                            last: data[i][1].trim(),
                            email: data[i][2].trim(),
                            company: data[i][3].trim(),
                            role: data[i][4] as Role,
                        });
                    }
                };
                await series();
                this.reload();
            }
        };
    }
}
